import React, { useState } from 'react';
import styles from './InitialVideoSpeedMenu.module.scss';
import cx from 'classnames';
import Icon from '../Icon/Icon';

const availableSpeedLevels = [0.8, 1, 1.2, 1.5, 1.7, 2, 2.5];

const InitialVideoSpeedMenu = ({ playbackRate, handleChangePlaybackRate }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className={cx(styles.videoSpeedContainer, { [styles.hoveredVideoSpeedContainer]: isHover })}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={event => event.stopPropagation()}
    >
      {isHover ? (
        <>
          {availableSpeedLevels.map(speedLevel => (
            <span
              key={speedLevel}
              onClick={() => handleChangePlaybackRate(speedLevel)}
              className={cx(styles.speed, { [styles.currentSpeed]: speedLevel === playbackRate })}
            >
              {speedLevel}x
            </span>
          ))}
        </>
      ) : (
        <div className={styles.initialSpeed}>
          <Icon src="videoSpeed" />
          <span>{playbackRate}x</span>
        </div>
      )}
    </div>
  );
};

export default InitialVideoSpeedMenu;
